import React from 'react';
import PropTypes from 'prop-types';
import AutoCompleteInput from './search';
import { styled } from '@mui/material';
import FilterPoints from './filter';

const SearchHeadingWrapper = styled('div')(() => ({
  width: '97%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginTop: '15px',
  gap: '15px',
  '@media(max-width: 768px)': {
    flexDirection: `column`,
  },
}));

function SearchHeading({ isLoaded }) {
  return (
    <>
      <SearchHeadingWrapper>
        <FilterPoints />
        <AutoCompleteInput isLoaded={isLoaded} />
      </SearchHeadingWrapper>
    </>
  );
}

SearchHeading.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  subdescription: PropTypes.string,
  icon: PropTypes.string,
  isLoaded: PropTypes.bool,
};

export default SearchHeading;
